module.exports = __webpack_public_path__ + "static/media/md-notifications-outline.8c92d157.svg";